const banner =
{
    buscadorPesqueria:
    {
        backgroundImage: "url('resources/fondo-pesqueria.jpg')"
    },
    buscadorAcuicultura:
    {
        backgroundImage: "url('resources/fondo-acuicultura.jpg')",
        backgroundPosition: 'top'
    }
}

export default banner;
